@if (uiFacade.inRequest$ | async) {
  <mat-progress-bar mode="query" color="primary"></mat-progress-bar>
} @else {
  <div class="no-request"></div>
}
